import { REMOVER_FILTRO_TOMADOR } from '../../types'

export default function removerFiltroTomador (filtro) {
  return {
    type: REMOVER_FILTRO_TOMADOR,
    payload: filtro
  }
}
